/** @jsx jsx */
import { jsx, Box } from 'theme-ui'
import React, { useState, useMemo, useRef, useEffect } from 'react'
import { animated, useTransition, config } from 'react-spring'
import { DialogOverlay, DialogContent } from '@reach/dialog'
import { ButtonBlock } from './ButtonBlock'
// import '@reach/dialog/styles.css'

export interface IModalProps {
  isOpen: boolean
  onClose?: () => void
  label: string
  header?: React.ReactNode
}
export const Modal: React.SFC<IModalProps> = ({
  isOpen,
  onClose,
  children,
  label,
  header,
  ...props
}) => {
  return (
    <React.Fragment>
      {isOpen && (
        <DialogOverlay
          onClick={() => onClose && onClose()}
          style={{
            background: 'hsla(0, 0%, 0%, 0.33)',
            position: 'fixed',
            top: '0',
            right: '0',
            bottom: '0',
            left: '0',
            overflow: 'auto',
          }}
          sx={{ zIndex: 10, p: 4 }}
        >
          <DialogContent
            aria-label={label}
            style={{
              position: 'relative',
              borderRadius: 10,
              width: '100%',
              outline: 'none',
            }}
            sx={{ maxWidth: '600px', mx: 'auto', bg: 'white' }}
            {...props}
          >
            {onClose && (
              <ButtonBlock
                onClick={() => onClose()}
                aria-label={`Close ${label} Dialogue`}
                css={{
                  position: 'absolute',
                  top: -9,
                  right: -9,
                  height: 30,
                  width: 30,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  lineHeight: '1',
                  fontSize: 20,
                  boxShadow: '0px 0px 6px 0px rgba(0,0,0,0.35)',
                  zIndex: 3,
                }}
                sx={{
                  bg: 'white',
                  borderRadius: 'pill',
                }}
              >
                &times;
              </ButtonBlock>
            )}
            {header && (
              <Box
                sx={{
                  bg: 'darkBlue',
                  color: 'white',
                  clipPath: 'polygon(0 0, 5760px 0, 5760px calc(100% - 322px), 0 100%)',
                  p: 4,
                  pb: 5,
                }}
              >
                {header}
              </Box>
            )}
            <Box sx={{ p: 4 }}>{children}</Box>
          </DialogContent>
        </DialogOverlay>
      )}
    </React.Fragment>
  )
}
